// extracted by css-extract-rspack-plugin
export default {"dot":"_9a2a9ac0","highSpecificity":"_e6c21155","active":"_ffea1413","mobile":"_ee836f1f"};